import { NAME_KEY, PAGES_KEY, PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import {
  clearMessages,
  createBackendErrorMessages,
  createErrorMessages,
  createWarningMessages,
  messagesReceived
} from "./message";
import {
  ALL_INDICATORS,
  CHOICE_CHOICE_NAME,
  CHOICE_NAME,
  CHOICE_TARGET,
  COLUMN_NAME,
  EDITING_PAGE_DESCRIPTION,
  EDITING_PAGE_KEY,
  EDITING_PAGE_TITLE,
  EDITING_PAGE_VISIBILITY,
  FIELD_NAME,
  FIELD_VALUE,
  GENERATE_NEW_OPTIONS,
  indexQuestionByProperty,
  INDICATOR_TO_BE_REPLACED,
  PAGE_NAME,
  PREDEFINED_LIST,
  PREDEFINED_LIST_TYPE,
  QUESTION_TO_COPY,
  QUESTION_TYPE,
  SHOW_MODAL_PAGE_EDITOR,
  TARGET_VALIDATORS,
  VALIDATOR
} from "./surveyEditor";

import rest from "../common/rest";
import { VALIDATOR_TYPE } from "../utils/ValidatorUtils";
import { jumpToPage } from "./surveyView";

export const ADD_QUESTION_ACTION = "surveyEditor.addQuestionAction";
export const COPY_QUESTION_ACTION = "surveyEditor.copyQuestionAction";
export const REMOVE_QUESTION_ACTION = "surveyEditor.removeQuestionAction";
export const ADD_QUESTION_CHOICE_ACTION = "surveyEditor.addQuestionChoiceAction";
export const REMOVE_QUESTION_CHOICE_ACTION = "surveyEditor.removeQuestionChoiceAction";
export const EDIT_SUBCHOICE_ACTION = "surveyEditor.editSubchoiceAction";
export const CONFIRM_SUBCHOICE_ACTION = "surveyEditor.confirmSubchoiceAction";
export const CANCEL_SUBCHOICE_ACTION = "surveyEditor.cancelSubchoiceAction";
export const ADD_PAGE_ACTION = "surveyEditor.addPageAction";
export const IMPORT_LIBRARY_SECTION = "surveyEditor.importLibrarySection";
export const IMPORT_LIBRARY_SECTIONS = "surveyEditor.importLibrarySections";
export const IMPORT_LIBRARY_QUESTIONS = "surveyEditor.importLibraryQuestions";

export function importLibraryQuestions(pageName, libraryQuestions) {
  return { type: IMPORT_LIBRARY_QUESTIONS, pageName, libraryQuestions };
}

export function importLibrarySection(section, sectionLibraryId) {
  return { type: IMPORT_LIBRARY_SECTION, section, sectionLibraryId };
}
export function importLibrarySections(sections) {
  return { type: IMPORT_LIBRARY_SECTIONS, sections };
}
export const EDIT_PAGE_ACTION = "surveyEditor.editPageAction";
export const REMOVE_PAGE_ACTION = "surveyEditor.removePageAction";
export const CHANGE_QUESTION_FIELD = "surveyEditor.changeQuestionField";
export const CHANGE_SELECTED_PAGE = "surveyEditor.changeSelectedPage";
export const REORDER_QUESTION = "surveyEditor.reorderQuestion";
export const REORDER_CHOICE = "surveyEditor.reorderChoice";
export const REORDER_PAGE = "surveyEditor.reorderPage";
export const FILTER_INVISIBLE = "surveyEditor.filterInvisible";
export const SET_TRIGGERS = "surveyEditor.setTriggers";
export const SET_VALIDATOR = "surveyEditor.setValidator";
export const SET_VALIDATOR_PROPERTY = "surveyEditor.setValidatorProperty";
export const RESET_PAGES_ACTION = "surveyEditor.resetPagesAction";
export const SET_PREDEFINED_LIST_ACTION = "surveyEditor.setPredefinedListAction";
export const ADD_INDICATOR_TO_QUESTION = "surveyEditor.addIndicatorToQuestion";
export const REMOVE_INDICATOR_FROM_QUESTION = "surveyEditor.removeIndicatorFromQuestion";
export const SET_INDICATORS_LIST_ACTION = "surveyEditor.setIndicatorsListAction";
export const MOVE_QUESTION_TO_PAGE = "surveyEditor.moveQuestionToPage";
export const PROPERTY_CHANGED_ACTION = "surveyEditor.propertyChangedAction";
export const PREPARE_DATA_FOR_EDITING_PAGE_ACTION = "surveyEditor.prepareDataForEditingPageAction";

export function addQuestion(pageName, questionType) {
  return {
    [TYPE_KEY]: ADD_QUESTION_ACTION,
    [PAGE_NAME]: pageName,
    [QUESTION_TYPE]: questionType
  };
}

export function copyQuestion(pageName, question) {
  return {
    [TYPE_KEY]: COPY_QUESTION_ACTION,
    [PAGE_NAME]: pageName,
    [QUESTION_TO_COPY]: question
  };
}

export function removeQuestion(pageName, questionName) {
  return {
    [TYPE_KEY]: REMOVE_QUESTION_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName
  };
}

export function addPage(page) {
  return {
    [TYPE_KEY]: ADD_PAGE_ACTION,
    page: page // optional
  };
}

export function editPage(
  selectedPage,
  editingPageTitle,
  editingPageKey,
  editingPageDescription,
  editingPageVisibility
) {
  return (dispatch, getCurrentState) => {
    if (checkPageKeyDuplicates(getCurrentState().surveyEditor, selectedPage, editingPageKey)) {
      dispatch(messagesReceived(createWarningMessages("template.activation.duplicate_key")));
    }

    dispatch({
      [TYPE_KEY]: EDIT_PAGE_ACTION,
      selectedPage: selectedPage,
      [EDITING_PAGE_TITLE]: editingPageTitle,
      [EDITING_PAGE_KEY]: editingPageKey,
      [EDITING_PAGE_DESCRIPTION]: editingPageDescription,
      [EDITING_PAGE_VISIBILITY]: editingPageVisibility
    });
  };
}

export function removePage(pageName) {
  return {
    [TYPE_KEY]: REMOVE_PAGE_ACTION,
    [PAGE_NAME]: pageName
  };
}

export function addQuestionChoice(pageName, questionName, choiceTarget, generateNewOptions) {
  return {
    [TYPE_KEY]: ADD_QUESTION_CHOICE_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [CHOICE_TARGET]: choiceTarget,
    [GENERATE_NEW_OPTIONS]: generateNewOptions
  };
}

export function removeQuestionChoice(pageName, questionName, choiceName, choiceTarget) {
  return {
    [TYPE_KEY]: REMOVE_QUESTION_CHOICE_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [CHOICE_NAME]: choiceName,
    [CHOICE_TARGET]: choiceTarget
  };
}

export function editSubchoice(pageName, questionName, choiceName, choiceTarget) {
  return {
    [TYPE_KEY]: EDIT_SUBCHOICE_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [CHOICE_NAME]: choiceName,
    [CHOICE_TARGET]: choiceTarget
  };
}

export function confirmSubchoice(pageName, questionName, choiceName, choiceTarget) {
  return {
    [TYPE_KEY]: CONFIRM_SUBCHOICE_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [CHOICE_NAME]: choiceName,
    [CHOICE_TARGET]: choiceTarget
  };
}

export function cancelSubchoice(pageName, questionName, choiceName, choiceTarget) {
  return {
    [TYPE_KEY]: CANCEL_SUBCHOICE_ACTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [CHOICE_NAME]: choiceName,
    [CHOICE_TARGET]: choiceTarget
  };
}

export function changeQuestionField(pageName, questionName, fieldName, fieldValue, choiceName, choiceTarget, choiceChoiceName, hideDuplicateMessage) {
  return (dispatch, getCurrentState) => {
    if (fieldValue === "predefinedList") {
      loadPredefinedList(pageName, questionName, fieldName, "countries")(dispatch);
    } else if (fieldName === "key" && !hideDuplicateMessage) {
      let duplicate = checkQuestionKeyDuplicates(getCurrentState().surveyEditor, fieldValue);
      if (duplicate) {
        dispatch(messagesReceived(createWarningMessages("template.activation.duplicate_key")));
      }
    } else if (
        (choiceTarget === "predefinedList" && fieldValue === "Radio") ||
        (choiceTarget === "predefinedList" && fieldValue === "Dropdown")
    ) {
      dispatch({
        [TYPE_KEY]: ADD_QUESTION_CHOICE_ACTION,
        [PAGE_NAME]: pageName,
        [NAME_KEY]: questionName,
        [CHOICE_TARGET]: "tempChoices",
        [GENERATE_NEW_OPTIONS]: true
      });
    }
    dispatch({
      [TYPE_KEY]: CHANGE_QUESTION_FIELD,
      [PAGE_NAME]: pageName,
      [NAME_KEY]: questionName,
      [FIELD_NAME]: fieldName,
      [FIELD_VALUE]: fieldValue,
      [CHOICE_NAME]: choiceName, // if omitted, will update the root question field; if set, then the choice field is updated
      [CHOICE_TARGET]: choiceTarget,
      [CHOICE_CHOICE_NAME]: choiceChoiceName
    });
  };
}

export function changeSelectedPage(selectedPage) {
  return (dispatch) => {
    dispatch(jumpToPage(selectedPage));
    dispatch({
      [TYPE_KEY]: CHANGE_SELECTED_PAGE,
      selectedPage: selectedPage
    });
  };
}

export function reorderQuestion(pageName, dragged, toBeReplaced) {
  return {
    [TYPE_KEY]: REORDER_QUESTION,
    [PAGE_NAME]: pageName,
    dragged: dragged,
    toBeReplaced: toBeReplaced
  };
}

export function reorderChoice(pageName, questionName, dragged, toBeReplaced, choiceTarget) {
  return {
    [TYPE_KEY]: REORDER_CHOICE,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    dragged: dragged,
    toBeReplaced: toBeReplaced,
    [CHOICE_TARGET]: choiceTarget
  };
}

export function reorderPage(dragged, toBeReplaced) {
  return {
    [TYPE_KEY]: REORDER_PAGE,
    dragged: dragged,
    toBeReplaced: toBeReplaced
  };
}

export function moveQuestionToPage(question, page) {
  return {
    [TYPE_KEY]: MOVE_QUESTION_TO_PAGE,
    questionToBeMoved: question,
    targetPage: page
  };
}

export function filterInvisible() {
  return {
    [TYPE_KEY]: FILTER_INVISIBLE
  };
}

export function setTriggers(pageName, questionName, triggers) {
  return {
    [TYPE_KEY]: SET_TRIGGERS,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    triggers: triggers
  };
}

export function setValidator(pageName, questionName, validator, target, columnName) {
  return {
    [TYPE_KEY]: SET_VALIDATOR,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [VALIDATOR]: validator,
    [TARGET_VALIDATORS]: target,
    [COLUMN_NAME]: columnName
  };
}

export function setValidatorProperty(
  pageName,
  questionName,
  validatorType,
  propertyName,
  propertyValue,
  target,
  columnName
) {
  return {
    [TYPE_KEY]: SET_VALIDATOR_PROPERTY,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [VALIDATOR_TYPE]: validatorType,
    [FIELD_NAME]: propertyName,
    [FIELD_VALUE]: propertyValue,
    [TARGET_VALIDATORS]: target,
    [COLUMN_NAME]: columnName
  };
}

export function resetPages() {
  return {
    [TYPE_KEY]: RESET_PAGES_ACTION,
    [PAGES_KEY]: []
  };
}

/**
 * Get languages for templates  from server, /admin/surveylanguages
 */
export function loadPredefinedList(pageName, questionName, fieldName, fieldValue) {
  return (dispatch) => {
    rest.doGet(`/admin/admin/predefined/` + fieldValue).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(json, pageName, questionName, fieldValue));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function checkQuestionKeyDuplicates(currentState, keyValue) {
  let keyIndex = indexQuestionByProperty(currentState, "key");
  let duplicate = keyIndex && keyIndex[keyValue];
  return duplicate;
}

export function checkPageKeyDuplicates(currentState, selectedPage, keyValue) {
  const pages = currentState[PAGES_KEY] || [];
  return pages.some(page => page.name !== selectedPage && page.key === keyValue);
}


export function loadSuccessful(json, pageName, questionName, fieldValue) {
  return {
    [TYPE_KEY]: SET_PREDEFINED_LIST_ACTION,
    [FIELD_NAME]: [PREDEFINED_LIST],
    [FIELD_VALUE]: json,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [PREDEFINED_LIST_TYPE]: fieldValue
  };
}

export function clearAllMessages() {
  return (dispatch) => {
    dispatch(clearMessages());
  };
}

/**
 * Get indicators   from server, /admin/indicators
 */
export function loadIndicators() {
  let indicatorFilterLink = "/admin/indicators";

  return (dispatch) => {
    rest.doGet(indicatorFilterLink).then(
      (json) => {
        if (json.indicators) {
          dispatch(loadIndicatorsSuccessful(json.indicators));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function loadIndicatorsSuccessful(json) {
  return {
    [TYPE_KEY]: SET_INDICATORS_LIST_ACTION,
    [FIELD_NAME]: [ALL_INDICATORS],
    [FIELD_VALUE]: json
  };
}

export function addIndicatorToQuestion(pageName, questionName, fieldName, fieldValue, targetId) {
  return {
    [TYPE_KEY]: ADD_INDICATOR_TO_QUESTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [FIELD_NAME]: fieldName,
    [FIELD_VALUE]: fieldValue,
    [INDICATOR_TO_BE_REPLACED]: targetId
  };
}

export function removeIndicatorFromQuestion(pageName, questionName, fieldName, fieldValue) {
  return {
    [TYPE_KEY]: REMOVE_INDICATOR_FROM_QUESTION,
    [PAGE_NAME]: pageName,
    [NAME_KEY]: questionName,
    [FIELD_NAME]: fieldName,
    [FIELD_VALUE]: fieldValue
  };
}

export function propertyChange(propertyName, propertyValue) {
  return {
    [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: propertyValue
  };
}

export function prepareDataForPageEditing(selectedPage, pageTitle, pageKey, pageDescription, pageVisibility) {
  return {
    [TYPE_KEY]: PREPARE_DATA_FOR_EDITING_PAGE_ACTION,
    [SHOW_MODAL_PAGE_EDITOR]: selectedPage,
    [EDITING_PAGE_TITLE]: pageTitle,
    [EDITING_PAGE_KEY]: pageKey,
    [EDITING_PAGE_DESCRIPTION]: pageDescription,
    [EDITING_PAGE_VISIBILITY]: pageVisibility
  };
}
